/* Căutarea inteligentă avempiese.ro — tolerantă la diacritice, greșeli de scriere, plural, sinonime și coduri de piesă.
   Lucrează pe lista compactă de produse (/collections/all?view=idx). */
(function () {
  'use strict';
  var APPS = {
    spalat:    { label: 'Mașină de spălat rufe', syn: 'masina spalat rufe automata' },
    frigider:  { label: 'Frigider și congelator', syn: 'frigider congelator combina frigorifica lada' },
    aragaz:    { label: 'Aragaz, cuptor, plită', syn: 'aragaz cuptor plita' },
    aspirator: { label: 'Aspirator', syn: 'aspirator' },
    vase:      { label: 'Mașină de spălat vase', syn: 'masina spalat vase' },
    microunde: { label: 'Cuptor cu microunde', syn: 'cuptor microunde' },
    uscator:   { label: 'Uscător de rufe', syn: 'uscator rufe' },
    boiler:    { label: 'Boiler', syn: 'boiler' },
    hota:      { label: 'Hotă', syn: 'hota' },
    espressor: { label: 'Espressor și cafetieră', syn: 'espressor cafetiera cafea' }
  };
  var STOP = new Set('de la pt pentru cu si sau din un o al a ale ai mi imi am vreau caut cauta cautam nevoie trebuie piesa piese pe mea meu mele mei ce care este e sa se ma va dumneavoastra noua nou buna ziua va rog'.split(' '));
  var SUF = ['urilor', 'ilor', 'elor', 'ului', 'uri', 'ele', 'ile', 'lor', 'ul', 'ua', 'ii', 'ei', 'le', 'ea', 'e', 'i', 'a', 'u'];
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[şș]/g, 's').replace(/[ţț]/g, 't');
  }
  function stem(t) {
    if (/\d/.test(t) || t.length <= 3) return t;
    for (var k = 0; k < SUF.length; k++) { var s = SUF[k]; if (t.endsWith(s) && t.length - s.length >= 3) return t.slice(0, -s.length); }
    return t;
  }
  var SYN_RAW = [
    ['garnitur', 'cauciuc', 'burduf', 'guma', 'gum', 'etans', 'etansar', 'chedar', 'garnitur'],
    ['inchizator', 'incuietoar', 'incuietor', 'zavor', 'blocar', 'broasc', 'yal'],
    ['amortizor', 'amortizoar', 'suspensi', 'arc'],
    ['evacuar', 'scurger', 'golire'],
    ['rezistent', 'incalzir', 'element'],
    ['termocupl', 'flacar', 'senzor'],
    ['electrovalv', 'ventil', 'valv'],
    ['cure', 'curel'],
    ['bec', 'lamp', 'lumin', 'led', 'beculet'],
    ['sac', 'pung', 'sacul'],
    ['hublou', 'usa', 'usi', 'geam'],
    ['carbun', 'periut'],
    ['buton', 'butoan', 'manet', 'potentiometr'],
    ['termostat', 'termostatul'],
    ['perie', 'peri', 'duz'],
    ['filtr', 'sit', 'plas'],
    ['brat', 'pulverizator', 'stropitor', 'elic'],
    ['farfuri', 'platan', 'tav'],
    ['arzator', 'ochi', 'arzatoar']
  ];
  var SYN_GROUPS = SYN_RAW.map(function (g) { var set = new Set(); g.forEach(function (w) { set.add(w); set.add(stem(w)); }); return Array.from(set); });
  var INTENT = {
    vas: 'vase', vase: 'vase', micround: 'microunde', uscator: 'uscator', uscatoar: 'uscator',
    frigider: 'frigider', congelator: 'frigider', combin: 'frigider', frigorific: 'frigider', lad: 'frigider', lada: 'frigider',
    aragaz: 'aragaz', plit: 'aragaz', cuptor: 'aragaz', aspirator: 'aspirator', aspiratoar: 'aspirator',
    boiler: 'boiler', hot: 'hota', hota: 'hota', espressor: 'espressor', expresor: 'espressor', espresor: 'espressor',
    cafetier: 'espressor', cafe: 'espressor', cafea: 'espressor', spalat: 'spalat', ruf: 'spalat', rufe: 'spalat'
  };
  var NEUTRAL = new Set(['masin', 'masina', 'aparat', 'electrocasnic', 'automat', 'automata']);

  function words(s) { return norm(s).replace(/[^a-z0-9]+/g, ' ').trim().split(' ').filter(Boolean); }
  function lev(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = []; for (var j0 = 0; j0 <= b.length; j0++) prev.push(j0);
    for (var i = 1; i <= a.length; i++) {
      var cur = [i], rowMin = i;
      for (var j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (cur[j] < rowMin) rowMin = cur[j];
      }
      if (rowMin > max) return max + 1;
      prev = cur;
    }
    return prev[b.length];
  }

  function buildIndex(products, extraApps) {
    var stemMap = new Map(), rawMap = new Map();
    var add = function (m, k, i) { var s = m.get(k); if (!s) { s = new Set(); m.set(k, s); } s.add(i); };
    products.forEach(function (p, i) {
      var A = APPS[p.a] || (extraApps && extraApps[p.a]) || { label: '', syn: '' };
      var text = [p.n, p.t, A.label, A.syn || '', p.b].join(' ');
      words(text).forEach(function (w) { add(rawMap, w, i); add(stemMap, stem(w), i); });
      p._compact = norm(p.n + ' ' + p.c).replace(/[^a-z0-9]/g, '');
    });
    return { products: products, stemMap: stemMap, rawMap: rawMap, stems: Array.from(stemMap.keys()), raws: Array.from(rawMap.keys()) };
  }

  function tokenMatches(idx, raw) {
    var out = new Map();
    var put = function (set, sc) { if (set) set.forEach(function (i) { if ((out.get(i) || 0) < sc) out.set(i, sc); }); };
    var st = stem(raw);
    if (/\d/.test(raw)) {
      if (raw.length >= 3) idx.products.forEach(function (p, i) { if (p._compact.indexOf(raw) > -1) put([i], 6); });
      return out;
    }
    put(idx.stemMap.get(st), 4);
    SYN_GROUPS.forEach(function (g) {
      var base = stem(g[0]);
      if (g.indexOf(st) > -1 && st !== base && st !== g[0]) { put(idx.stemMap.get(base), 3.5); put(idx.stemMap.get(g[0]), 3.5); }
    });
    if (raw.length >= 3) idx.raws.forEach(function (r) { if (r !== raw && r.indexOf(raw) === 0) put(idx.rawMap.get(r), 2.5); });
    idx.stems.forEach(function (s) {
      if (s === st) return;
      if (s.length >= 5 && st.indexOf(s) === 0) { put(idx.stemMap.get(s), 2); return; }
      if (st.length >= 4 && !/\d/.test(s)) {
        var max = st.length <= 6 ? 1 : 2;
        if (lev(st, s, max) <= max) put(idx.stemMap.get(s), 1.5);
      }
    });
    return out;
  }

  function search(idx, query) {
    var raws = Array.from(new Set(words(query))).filter(function (w) { return !STOP.has(w); });
    var compactQ = norm(query).replace(/[^a-z0-9]/g, '');
    var intent = null, need = [];
    var hasVase = raws.some(function (w) { return ['vase', 'vas'].indexOf(stem(w)) > -1 || w === 'vase'; });
    raws.forEach(function (w) {
      var s = stem(w), it = INTENT[w] || INTENT[s];
      if (NEUTRAL.has(w) || NEUTRAL.has(s)) return;
      if (it) {
        var v = it;
        if (v === 'spalat' && hasVase) v = 'vase';
        if (v === 'aragaz' && raws.some(function (x) { return stem(x) === 'micround'; })) v = 'microunde';
        if (v === 'spalat' && raws.some(function (x) { return stem(x).indexOf('uscator') === 0; })) v = 'uscator';
        if (!intent || (intent === 'spalat' && v !== 'spalat') || (intent === 'aragaz' && v === 'microunde')) intent = v;
        return;
      }
      need.push(w);
    });
    var P = idx.products, scored = new Map(), partial = false;
    if (need.length) {
      var maps = need.map(function (w) { return tokenMatches(idx, w); });
      maps[0].forEach(function (sc, i) {
        var total = sc, ok = true;
        for (var k = 1; k < maps.length; k++) { var v = maps[k].get(i); if (!v) { ok = false; break; } total += v; }
        if (ok) scored.set(i, total);
      });
      if (!scored.size && maps.length > 1) {
        partial = true;
        maps.forEach(function (m) { m.forEach(function (sc, i) { scored.set(i, (scored.get(i) || 0) + sc + 10); }); });
        var best = Math.max.apply(null, Array.from(scored.values()));
        scored.forEach(function (sc, i) { if (sc < best - 10) scored.delete(i); });
      }
    } else if (intent) {
      P.forEach(function (p, i) { if (p.a === intent) scored.set(i, 1); });
    }
    if (compactQ.length >= 5 && /\d/.test(compactQ)) {
      P.forEach(function (p, i) { if (p._compact.indexOf(compactQ) > -1) scored.set(i, (scored.get(i) || 0) + 20); });
    }
    var list = Array.from(scored).map(function (e) { return { p: P[e[0]], s: e[1] }; });
    if (intent) {
      var inApp = list.filter(function (r) { return r.p.a === intent; });
      if (inApp.length) list = inApp; else list.forEach(function (r) { if (r.p.a === intent) r.s += 4; });
    }
    list.sort(function (a, b) { return b.s - a.s || (b.p.s || 0) - (a.p.s || 0) || a.p.n.length - b.p.n.length; });
    return { list: list.map(function (r) { return r.p; }), intent: intent, partial: partial, terms: need };
  }

  window.APSearch = { buildIndex: buildIndex, search: search, norm: norm, APPS: APPS };
})();
